import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_seller_filter_item = _resolveComponent("seller-filter-item");
  const _component_selected_section = _resolveComponent("selected-section");
  const _component_list_section = _resolveComponent("list-section");
  const _component_WrapWithDropdownBody = _resolveComponent("WrapWithDropdownBody");
  return _openBlock(), _createBlock(_component_WrapWithDropdownBody, {
    isModified: $props.isModified,
    actionsText: $props.pendingChanges,
    name: $props.title,
    keyword: $props.keyword,
    searchPlaceholder: "Search sellers...",
    debounce: false,
    onHidden: _cache[3] || (_cache[3] = $event => _ctx.$emit('hidden')),
    onDiscard: _cache[4] || (_cache[4] = $event => _ctx.$emit('discard')),
    onApply: _cache[5] || (_cache[5] = $event => _ctx.$emit('apply')),
    onCloseDropdown: _cache[6] || (_cache[6] = $event => _ctx.$emit('closeDropdown')),
    onSearch: _cache[7] || (_cache[7] = val => _ctx.$emit('search', val)),
    onRestoreSearch: _cache[8] || (_cache[8] = $event => _ctx.$emit('restoreSearch'))
  }, {
    selected: _withCtx(() => [_createVNode(_component_selected_section, {
      title: "Sellers",
      count: $props.selected.length,
      onClear: _cache[0] || (_cache[0] = $event => _ctx.$emit('clear')),
      onApply: _cache[1] || (_cache[1] = $event => _ctx.$emit('apply')),
      onCloseDropdown: _cache[2] || (_cache[2] = $event => _ctx.$emit('closeDropdown')),
      isModified: $props.isModified,
      no_reset: $props.no_reset
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.selected, item => {
        return _openBlock(), _createBlock(_component_seller_filter_item, {
          key: item.id,
          name: item.name,
          id: item.id,
          region: item.region,
          item: item,
          query: $props.keyword,
          no_reset: $props.no_reset,
          selected: "",
          onDeselect: item => _ctx.$emit('deselect', item)
        }, null, 8, ["name", "id", "region", "item", "query", "no_reset", "onDeselect"]);
      }), 128))]),
      _: 1
    }, 8, ["count", "isModified", "no_reset"])]),
    list: _withCtx(() => [_createVNode(_component_list_section, {
      title: "Sellers",
      count: $props.list.length,
      searching: $props.isSearching,
      keyword: $props.keyword
    }, {
      default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.list, item => {
        return _openBlock(), _createBlock(_component_seller_filter_item, {
          key: item.id,
          name: item.name,
          id: item.id,
          region: item.region,
          item: item,
          query: $props.keyword,
          onSelect: item => _ctx.$emit('select', item),
          onSelectOnly: item => _ctx.$emit('selectOnly', item)
        }, null, 8, ["name", "id", "region", "item", "query", "onSelect", "onSelectOnly"]);
      }), 128))]),
      _: 1
    }, 8, ["count", "searching", "keyword"])]),
    _: 1
  }, 8, ["isModified", "actionsText", "name", "keyword"]);
}